import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Subject } from 'rxjs';

interface Location{
  latitude: string;
  longitude: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataService {

  notificationsCount: Subject<number> = new BehaviorSubject<number>(0);
  constructor(private http: HttpClient) { }

  getNotifyWPA(){
    return this.http.get('https://notify.securenow.in')
  }

  getLocation(){
    return this.http.get<Location>('https://maps.googleapis.com/maps/api/js?key=AIzaSyDEO050WW2oVBD41FKAl3gSSIo9W_mnl3g')
  }
}
